// 3-D Secure only accepts these values for the browser colour depth (EMVCo browserColorDepth).
// Modern displays report 30 (HDR), which the issuer rejects, so snap anything outside the
// permitted set to the nearest permitted value (30 → 32, matching what the PAS card-add flow has
// always sent).
const THREE_DS_COLOR_DEPTHS = [1, 4, 8, 15, 16, 24, 32, 48];
const DEFAULT_COLOR_DEPTH = '24';

export const getThreeDsColorDepth = colorDepth => {
  const depth = Number(colorDepth);
  if (!Number.isFinite(depth) || depth <= 0) {
    return DEFAULT_COLOR_DEPTH;
  }

  const nearest = THREE_DS_COLOR_DEPTHS.reduce((best, candidate) => {
    const distance = Math.abs(candidate - depth);
    const bestDistance = Math.abs(best - depth);
    // Prefer the higher value on a tie
    return distance < bestDistance || (distance === bestDistance && candidate > best)
      ? candidate
      : best;
  });

  return String(nearest);
};
